import { useState } from "react";
import SelectInputFromForm from "../SelectInputFromForm";
import TextInput from "../TextInput";

interface Props {
  id: any;
  value: any;
  index?: any;
  options: any;
  handleFormItem: any;
}

export default function MetricInput(props: Props) {
  const { id, value, index, handleFormItem, options } = props;

  const [metric, setMetric] = useState(value?.metric ?? "");
  const [text, setText] = useState(value?.value || "");

  return (
    <>
      <div className="flex flex-row gap-3">
        <SelectInputFromForm
          className="max-w-[30%] w-full"
          options={options}
          value={metric}
          onChange={(e) => {
            handleFormItem({ metric: e.target.value, value: text }, id, index);
            setMetric(e.target.value);
          }}
        />
        <TextInput
          placeholder="Valor…"
          variant="outlined"
          value={text
            ?.replace(",", ".")
            ?.replace(/[^0-9.]+/g, "")
            ?.replace(/(\..*)\./g, "$1")}
          onChange={(e) => {
            const updatedText = e.target.value
              ?.replace(",", ".")
              ?.replace(/[^0-9.]+/g, "")
              ?.replace(/(\..*)\./g, "$1");
            handleFormItem({ metric, value: updatedText }, id, index);
            setText(updatedText);
          }}
        />
      </div>
    </>
  );
}
